module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hres6oe-cust-latlng",
      "id": "hres6oe-cust-latlng",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    ref: "btnCloseModal",
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRES6OEC3']['10']))])]), _vm._v(" "), _c('hrms-search-box-table', {
    ref: "custNearSelect",
    attrs: {
      "data": _vm.data,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.placeNewLatLngColumns,
      "receivedStore": _vm.receivedCheckInPlaceNoLocation,
      "searchBoxAlias": "hres6oe",
      "searchDisp": false,
      "selectRowBool": true,
      "selectBtnDisp": true,
      "selectEvent": _vm.selectEvent,
      "confirmSelectBtnDisp": true,
      "unLoadBool": true
    },
    model: {
      value: (_vm.searchIndexLocation),
      callback: function($$v) {
        _vm.searchIndexLocation = $$v
      },
      expression: "searchIndexLocation"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c9f8c91!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6oe/custNewLatLng.vue
// module id = 3651
// module chunks = 1